import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'deleteReading',
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: {
        clockOver: false,
        meterId: 0,
        reading: 0,
        readingDate: null,
        readingNumber: 0,
        readingReason: '',
        readingTime: ''
      },
      readingDateView: null,
      
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      readingsCols: [],
      readings: [],
      noDataFound: false,
      keyColumn: 'readingNumber'
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('delete_reading_updated', this.init);
    this.fillReadingsCol();
    this.init();
  },
  watch: {
    readingDateView: function (val) {
      this.appData.readingDate = moment(val, "DD/MM/YYYY").add(1, 'days');
    }
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
        this.readingDateView = this.$options.filters.formatDateDDMMYYY(this.appData.readingDate);

        this.getReadings();
      });
    },
    getReadings() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Options: this.options
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/DeleteReadingActivity/GetReadings', parameter),
        response => {
          if (response.data.items.length == 0) {
            this.readings = [];
            this.noDataFound = true;
          }
          else {
            this.readings = response.data.items;
            this.options.total = response.data.itemsCount;
            this.totalRow = response.data.itemsCount;
          }
          this.$root.$emit('datagrid_updated');
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/DeleteReadingActivity/GetReadings', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      console.log(response.data);

      //      if (response.data.items.length == 0) {
      //        this.readings = [];
      //        this.noDataFound = true;
      //      }
      //      else {
      //        this.readings = response.data.items;
      //        this.options.total = response.data.itemsCount;
      //        this.totalRow = response.data.itemsCount;
      //      }
      //      this.$root.$emit('datagrid_updated');
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text)
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.data);
      //  });
    },
    pageChange(pInfo) {
      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getReadings();
    },
    fillReadingsCol() {
      this.readingsCols.push({ dataField: 'readingNumber', caption: this.$t('activities.readingNo') });
      this.readingsCols.push({ dataField: 'readingDate', caption: this.$t('activities.readingDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.readingsCols.push({ dataField: 'readingTime', caption: this.$t('activities.readingTime') });
      this.readingsCols.push({ dataField: 'reading', caption: this.$t('activities.reading') });
      this.readingsCols.push({ dataField: 'clockOver', caption: this.$t('activities.clockOver'), dataType: 'boolean' });
      this.readingsCols.push({ dataField: 'isInvoiced', caption: this.$t('activities.billed'), dataType: 'boolean' });
    }
  },
}
